import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from "@angular/core";
import { LoginService } from "../login.service";
import { HttpClient } from "@angular/common/http";
import { PatientsService } from "../patients.service";
import { Patient } from "./patient";
import { ExamsService } from "../exams.service";
import { Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GastroFormsService } from "../gastro-forms.service";
import { GastroService } from "../gastro.service";
import * as XLSX from "xlsx";
import { SignatureService } from "../signature.service";
import { writeFile } from "xlsx";
import { DatePipe } from "@angular/common";
import { SPINNER_FADEOUT_DURATION } from '../app.constants';
import { pageCount, hasMorePages, shouldShowControls, resolveTotal, debouncedSearch } from "../pagination";
import {
  NO_SEND_HMOS,
  OTHER_HMOS_SCOPE,
  ReportFailCase,
  ReportFailCounts,
} from "../exams.service";
import { ReportSearchCriteria, ReportSearchMode } from "../searchbox/searchbox.component";

@Component({
    selector: "app-patients",
    templateUrl: "./patients.component.html",
    styleUrls: ["./patients.component.scss"],
    standalone: false
})
export class PatientsComponent implements OnInit, OnDestroy {
  @ViewChild("swipeField") swipeField: ElementRef;
  showExcel = false;
  showprintopts = false;
  showprint = false;
  inform = false;
  id: string;
  first: string;
  last: string;
  phone: string;
  idp = 1;
  showhelp: boolean = false;
  selectedPatient: Patient;
  formSelected: any;
  invalidi: string = "";
  invalidf: string = "";
  invalidl: string = "";
  patList: Patient[];
  isAWL = false;
  AWLStatus = "Waiting";
  AWLExam = "All";
  AWLlist: Patient[];
  examList;
  examReportResults: any[] | null = null;
  patientsearch = true;
  fromd: Date;
  tod: Date;
  openEsearch = false;
  isReports = false;
  hmostype;
  exams;
  typeForm;
  examMode = "All";
  examNames = [
    "1st",
    "NT",
    "Early",
    "2nd/3rd",
    "Late",
    "Specialized",
    "Fetal Echo",
    "Gynecology",
    "Weight Assessment",
    "Tech Exam",
    "Emergency Room",
    "Amniocentesis",
    "CVS",
    "Follicles",
  ];
  examNamesGastro = ["Gastroscopy", "Colonoscopy", "Sigmoidoscopy"];
  cardioTodayListExams = [
    "אקו",
    "אקו לב",
    "אקו מכבי",
    "אקו לאומית",
    "אקו מאוחדת",
    "אקו לב במאמץ",
    "אקו במאמץ מכבי",
    "אקו במאמץ לאומית",
    "אקו במאמץ מאוחדת",
    "אקו במאמץ פרטי",
    "ארגומטריה",
    "ארגומטריה מכבי",
    "ארגומטריה לאומית",
    "ארגומטריה מאוחדת",
    "הולטר קצב לב",
    "בדיקת אקג",
    "קרוטיד US עורקי צואר",
    "ייעוץ קרדיולוגי",
    "יעוץ רפואי מכבי",
    "יעוץ רפואי לאומית",
    "יעוץ רפואי מאוחדת",
    "יעוץ רפואי כללית מושלם",
  ];
  reportsNames = ["Refferelnum", "Macabi", "HMO", "AllReports"];
  examVals = {};
  chosenAWL: number;
  awlTime: string;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  prn: string;
  code: string;
  swiping = false;
  card: string;
  idcode: string;
  carderror: string;
  expcode: string;
  GA;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  showpayment: string;
  cardtzsearch: string;
  goEx = { preg: null, exam: null, etype: null };
  showLogin = false;
  startClinic: number;
  private destroy$ = new Subject();
  // Debounced (300ms) patient-search trigger; emits the composed query key for distinctUntilChanged.
  private searchTrigger$ = new Subject<string>();
  // Pagination state (server supports OFFSET…FETCH NEXT; pageSize matches backend default).
  currentPage: number = 1;
  pageSize: number = 25;
  hasMore: boolean = false;
  showPaginationControls: boolean = false;
  totalResults: number = 0;
  // Total pages derived from the backend's COUNT(*) OVER() total.
  get totalPages(): number {
    return pageCount(this.totalResults, this.pageSize);
  }
  sub = new Subscription();
  startdate;
  enddate;
  changedExamCode;
  reportName = null;
  sentMacabi = false;
  openConcentForm;
  concentForm;
  last_search_time;
  toreassign;
  showPopUp = false;
  examReportLoading = false;
  examReportFading = false;
  examListLoading = false;
  examListFading = false;
  awlListLoading = false;
  awlListFading = false;
  patListLoading = false;
  patListFading = false;
  examReportColumns = ['name', 'patientId', 'signedDate', 'examType', 'xmlStatus'];
  // 'Others' is the private / IDF / unassigned group (OTHER_HMOS_SCOPE), which
  // the API cannot filter on and is narrowed from an all-HMOs search instead.
  reportSearchHmo: 'Clalit' | 'Leumit' | 'Meuhedet' | 'Macabi' | 'Private' | 'IDF' | 'null' | 'All' | 'Others' | '' = '';
  reportSearchExamType = 'All';
  // True when the current results came from a "Status By HMO" search. Only
  // those carry the failure-case checkboxes; a plain All / By HMO search just
  // lists the period.
  reportStatusMode = false;
  // The one failure case the listed rows are narrowed to (null until the
  // secretary picks one), the count each case holds, and the rows behind those
  // counts. The buckets are fetched once per status search, so switching cases
  // re-lists what is already loaded instead of searching again.
  reportFailCase: ReportFailCase = null;
  reportFailCounts: ReportFailCounts = null;
  private reportFailBuckets: any = null;
  // True when the current results are only the "Not Signed" case. Those exams
  // have no send status at all, so the status column is replaced with the
  // signature state instead of showing a misleading "Not sent".
  reportSearchNotSigned = false;
  unreadLabReports = 0;
  unassignedLabReports = 0;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patQuestionnaireAnswered: { [awlid: number]: boolean } = {};

  constructor(
    public gs: GastroService,
    public loginService: LoginService,
    public patservice: PatientsService,
    public exServ: ExamsService,
    private rt: Router,
    public gfs: GastroFormsService,
    public signatureService: SignatureService,
    private http: HttpClient
  ) {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
    this.examNames = [
      "Gastroscopy",
      "Colonoscopy",
      "Sigmoidoscopy",
      "Abdomen US",
      "Hemorrhoids Treatment",
    ];
    // this.AWLStatus ="All";

    for (let e of this.examNames) this.examVals[e] = true;
  }

  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  clear() {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
    if (this.isAWL) this.search();
  }

  ngOnInit() {
    // Debounce keystroke searches: fire 300ms after typing stops, skip unchanged queries.
    debouncedSearch(this.searchTrigger$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.runSearch());
    let now = new Date();
    let ndate =
      now.getFullYear() +
      "-" +
      (now.getMonth() + 1 < 10 ? "0" : "") +
      (now.getMonth() + 1) +
      "-" +
      (now.getDate() < 10 ? "0" : "") +
      now.getDate();
    now = new Date(ndate);
    this.tod = now;
    this.fromd = now;
    this.loginService.loginMissing();
    if (this.loginService.showAWL()) {
      if (this.loginService.lastAwl) {
        this.AWLStatus = this.loginService.lastAwl;
      }
      if (this.loginService.lastAwlExam) this.AWLExam = this.loginService.lastAwlExam;
      if (this.loginService.lastAwlStartDate && this.loginService.lastAwlEnDate) {
        this.startdate = this.loginService.lastAwlStartDate;
        this.enddate = this.loginService.lastAwlEnDate;
      }
      if (!this.exServ.searchReport && !this.loginService.lastSearchOrigin) this.AWL();
    }
    this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (
        (this.goEx.preg && this.goEx.exam && this.goEx.etype) ||
        (this.goEx && (this.loginService.isGastro || this.loginService.isCardio))
      ) {
        this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
    });
    this.patservice.exitFromGastroExam.subscribe(() => {
      this.AWLStatus = this.patservice.AWLStatus;
      this.loginService.lastAwl = "All";
    });
    this.patservice.awlIncomming.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.isAWL) this.AWL();
    });
    if (this.loginService.lastSearchOrigin) {
      this.restoreSearchOrigin(this.loginService.lastSearchOrigin);
    } else if (this.exServ.searchReport) {
      this.fromd = this.exServ.searchReport.start;
      this.tod = this.exServ.searchReport.end;
      this.reportName = this.exServ.searchReport.type;
      this.hmostype = this.exServ.searchReport.hmo;
      this.isReports = true;
      this.AWLlist = null;
      this.searchClosed([this.fromd, this.tod, [], this.reportName, this.hmostype]);
      // this.examSearch(this.reportName, this.hmostype);
    }

    this.sub = this.loginService.export$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (!data) {
        this.exServ.searchReport = null;
      }
    });
    setTimeout(() => {
      //moves to patients before permissions are set
      if(this.loginService.premissions && this.loginService.premissions['GastroLabReports'] && this.loginService.userType == 'doctor'){
        //get number of unread/unassigned reports
        this.gs.getUnreadLabReports().subscribe((data:any)=>{
          this.unreadLabReports = data.UnreadCount;
          this.unassignedLabReports = data.UnassignedCount;
        });
      }
    }, 300);
  }

  addPatient() {
    if (
      !this.loginService.doctor &&
      this.loginService.userType !== "doctor" &&
      this.loginService.separatedClinic
    ) {
      this.showPopUp = true;
      return;
    }
    this.invalidi = "";
    if (this.id.length < 7) {
      this.invalidi = "is-invalid";
      return;
    }
    this.invalidf = "";
    if (this.first == "") {
      this.invalidf = "is-invalid";
      return;
    }
    this.invalidl = "";
    if (this.last == "") {
      this.invalidl = "is-invalid";
      return;
    }
    this.selectedPatient = new Patient(this.id, this.first, this.last, this.phone);
  }

  onClosed(closed: string) {
    if (closed) this.selectedPatient = null;
    if (closed == "awl") {
      this.clear();
      this.AWL();
    } else if (this.patList) this.search(); //to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;
  }

  search(noawl = false) {
    this.examList = null;
    this.examReportResults = null;
    this.exServ.searchReport = null;
    this.isReports = false;
    this.carderror = null;
    if (this.isAWL && !noawl) {
      this.patList = null;
      this.awlListLoading = true;
      if ((this.startdate, this.enddate)) {
        var start =
          this.startdate._i.year +
          "-" +
          (this.startdate._i.month + 1) +
          "-" +
          this.startdate._i.date +
          " 00:00:00.000";
        var end =
          this.enddate._i.year +
          "-" +
          (this.enddate._i.month + 1) +
          "-" +
          this.enddate._i.date +
          " 23:59:59.000";
      }
      this.patservice
        .getAWL(this.AWLStatus, this.AWLExam, {
          id: this.id,
          first: this.first,
          last: this.last,
          start: start,
          end: end,
          uid: this.loginService.doctor,
        })
        .subscribe(
          (patients: Patient[]) => {
            if (patients.length > 0) {
              this.GaArray = [];
              patients.forEach((i) => {
                var GAitem = this.lmpGA(i.ExamLMP);
                this.GaArray.push(GAitem);
                if (i.UID) i["nUID"] = i.UID;
              });
            }
            this.AWLlist = patients;
            this.loadQuestionnaireStatuses(patients);
            this.awlListFading = true;
            setTimeout(() => {
              this.awlListLoading = false;
              this.awlListFading = false;
            }, SPINNER_FADEOUT_DURATION);
            if (this.cardtzsearch) {
              this.swiping = false;
              for (let pat of this.AWLlist) {
                let zeros = pat.ID;
                while (zeros.length < 9) zeros = "0" + zeros;
                if (pat.ID == this.cardtzsearch || zeros == this.cardtzsearch) {
                  this.setAWL(pat);
                  this.selectedPatient = pat;
                  if (this.selectedPatient.HMO != "Macabi") {
                    //now for macabi only
                    this.selectedPatient.HMO = "Macabi";
                    this.patservice
                      .savePatient(this.selectedPatient, this.selectedPatient.PID)
                      .subscribe(
                        (data) => {},
                        (error) => {
                          console.log(error);
                        }
                      );
                  }
                  this.showpayment = this.cardtzsearch;
                  this.cardtzsearch = null;
                }
              }
              if (this.cardtzsearch) {
                this.carderror = this.cardtzsearch;
                this.cardtzsearch = null;
              }
            }
          },
          (error) => {
            console.log(error);
            this.awlListFading = true;
            setTimeout(() => {
              this.awlListLoading = false;
              this.awlListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
    } else {
      this.AWLlist = null;
      this.patListLoading = true;
      // A fresh search always starts from the first page.
      this.currentPage = 1;
      this.showPaginationControls = false;
      // this.visitPat = null;
      this.patservice.getPatients(
        this.id,
        this.first,
        this.last,
        this.phone,
        this.loginService.doctor,
        (patients: Patient[]) => {
          this.isAWL = false;
          this.applyPatientPage(patients);
          this.patListFading = true;
          setTimeout(() => {
            this.patListLoading = false;
            this.patListFading = false;
          }, SPINNER_FADEOUT_DURATION);
        },
        this.currentPage,
        this.pageSize,
        () => {
          // A failed request must still clear the spinner, or it spins forever.
          this.patListFading = true;
          setTimeout(() => {
            this.patListLoading = false;
            this.patListFading = false;
          }, SPINNER_FADEOUT_DURATION);
        }
      );
    }
    // }
  }

  nextPage() {
    this.currentPage++;
    this.loadPatients();
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPatients();
    }
  }

  // Re-fetch the current page (used by next/previous); keeps the spinner and pagination state in sync.
  loadPatients() {
    this.patListLoading = true;
    this.patservice.getPatients(
      this.id,
      this.first,
      this.last,
      this.phone,
      this.loginService.doctor,
      (patients: Patient[]) => {
        this.applyPatientPage(patients);
        this.patListFading = true;
        setTimeout(() => {
          this.patListLoading = false;
          this.patListFading = false;
        }, SPINNER_FADEOUT_DURATION);
      },
      this.currentPage,
      this.pageSize,
      () => {
        // A failed request must still clear the spinner, or it spins forever.
        this.patListFading = true;
        setTimeout(() => {
          this.patListLoading = false;
          this.patListFading = false;
        }, SPINNER_FADEOUT_DURATION);
      }
    );
  }

  // Populate the current page and derive pagination state from the backend's exact total.
  private applyPatientPage(patients: Patient[]) {
    this.patList = [];
    for (let i = 0; i < patients.length; i++) {
      let pat = new Patient();
      pat.asignVals(patients[i]);
      this.patList[i] = pat;
    }
    // COUNT(*) OVER() rides on every row; fall back to page length if it's ever absent.
    this.totalResults = resolveTotal(patients as any);
    this.hasMore = hasMorePages(this.currentPage, this.pageSize, this.totalResults);
    this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
  }

  trysearch() {
    // Sanitize the ID synchronously (input reflects it), then hand off to the debounced trigger.
    this.id = this.id.replace(/\-/g, "_").replace(/\W/g, "").replace(/_/g, "-");
    this.searchTrigger$.next(`${this.id}|${this.first}|${this.last}|${this.phone}`);
  }

  // Debounced search handler — same decision logic that trysearch() used to run inline.
  private runSearch() {
    if (!this.isSearchDisabled())
      this.search(!this.loginService.ishospital); //for clinics search works on patients - not awl
    if (this.isAWL && this.id.length == 0 && this.first.length == 0 && this.last.length == 0)
      //when cleared
      this.search();
  }

  // Single source of truth for the search gate (>=2 chars); shared by auto-search and the Search button.
  // Button gate: the content rule plus an in-flight check, so the button can't be spammed while a search is pending.
  // Kept separate from isSearchDisabled() so a request in flight never blocks the debounced auto-search.
  get isSearchButtonDisabled(): boolean {
    return this.awlListLoading || this.patListLoading || this.isSearchDisabled();
  }

  isSearchDisabled(): boolean {
    return !(
      this.id.trim().length > 1 ||
      this.first.trim().length > 1 ||
      this.last.trim().length > 1 ||
      this.phone.trim().length > 1
    );
  }

  AWL(savestatus = true, type = null) {
    if (!this.enddate && this.startdate) {
      this.enddate = this.startdate;
    } else if (!this.startdate && this.enddate) {
      this.startdate = this.enddate;
    }
    if (savestatus) {
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;
    }
    this.isAWL = true;
    this.examList = null;
    this.examReportResults = null;
    this.exServ.searchReport = null;
    this.loginService.lastSearchOrigin = null;
    this.search();
    this.patservice.openWebSocket(!this.loginService.ishospital ? this.loginService.ClinicID : null);
  }

  switchSearch() {
    this.patientsearch = !this.patientsearch;
    if (!this.patientsearch) this.examSearch();
    else this.examList = [];
    this.examReportResults = [];
  }

  examSearch(reportName = null, hmo = null) {
    this.isAWL = false;
    this.AWLlist = null;
    this.examReportResults = null;
    this.visitPat = null;
    this.patList = null;
    this.examListLoading = true;
    if (reportName) {
      this.isReports = true;
      this.reportName = reportName;
      this.hmostype = hmo;
      this.exServ.searchReport = { start: this.fromd, end: this.tod, type: reportName, hmo: hmo };
      this.exServ
        .reportSearch(this.fromd, this.tod, reportName, hmo, this.loginService.doctor)
        .subscribe(
          (data) => {
            this.examList = data;
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
          (error) => {
            console.log(error);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
    } else {
      this.exServ.searchReport = null;
      this.isReports = false;
      this.exServ.examSearch(this.fromd, this.tod, this.examVals, this.loginService.doctor).subscribe(
        (data) => {
          this.examList = data;
          this.examListFading = true;
          setTimeout(() => {
            this.examListLoading = false;
            this.examListFading = false;
          }, SPINNER_FADEOUT_DURATION);
        },
        (error) => {
          console.log(error);
          this.examListFading = true;
          setTimeout(() => {
            this.examListLoading = false;
            this.examListFading = false;
          }, SPINNER_FADEOUT_DURATION);
        }
      );
    }
  }

  goPatient(pid: number) {
    this.patservice.getPatient(pid, (s) => {
      if (s) this.rt.navigate(["/exams"], { state: { data: this.patservice.currentPatient } });
    });
  }

  getLocked(exam) {
    var now = new Date();
    var lockedTime = new Date(exam.Locked);
    var lock = true;
    if (
      now.getDate() != lockedTime.getDate() ||
      now.getMonth() != lockedTime.getMonth() ||
      now.getFullYear() != lockedTime.getFullYear() ||
      now.getHours() - lockedTime.getHours() > 1
    ) {
      lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && !this.loginService.isAdmin) return "locked";
    return "unlocked";
  }

  viewonly() {
    this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  goExam(exam /*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/) {
    // Only the two search-results lists call goExam, so remember which search we
    // came from — closing the exam should land back on these results.
    this.rememberSearchOrigin();
    let preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
    let id = exam.AutoIndex;
    this.patservice.getPatient(exam.PID, (s) => {
      if (s) {
        if (exam.Locked && exam.LockedBy && !this.loginService.isAdmin) return;

        if (
          exam.ExamType !== "Emergency Room" &&
          !this.signatureService.isExamSigned(exam) &&
          (this.loginService.userType === "doctor" ||
            this.loginService.userType === "visitingdoc" ||
            this.loginService.userType === "tech")
        ) {
          this.showLogin = false;
          // Enter exam as view only from the search exam:
          this.exServ.goExam(preg, exam, exam.ExamType, true);
          // this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
          if (this.loginService.ClinicID) {
            this.startClinic = this.loginService.ClinicID;
          }
        } else {
          this.exServ.goExam(preg, exam, exam.ExamType, s.PID);
        }
      }
    });
  }
  // Snapshot of the search whose results are currently listed, kept on the login
  // service so it survives leaving and re-entering this component.
  private rememberSearchOrigin() {
    if (this.isReports && this.examReportResults) {
      this.loginService.lastSearchOrigin = {
        kind: "reports",
        start: this.fromd,
        end: this.tod,
        criteria: this.loginService.lastReportSearch,
        failCase: this.reportFailCase,
      };
    } else if (this.isReports && this.reportName) {
      this.loginService.lastSearchOrigin = {
        kind: "legacyReport",
        start: this.fromd,
        end: this.tod,
        reportName: this.reportName,
        hmo: this.hmostype,
      };
    } else if (this.examList) {
      this.loginService.lastSearchOrigin = {
        kind: "exams",
        start: this.fromd,
        end: this.tod,
        exams: { ...this.examVals },
        mode: this.examMode,
      };
    } else {
      this.loginService.lastSearchOrigin = null;
    }
  }

  // Re-runs the search an exam was opened from, when coming back to this page.
  // One-shot: once restored, only re-opening an exam from these results arms it
  // again, so entering an exam by any other route still exits to the today list.
  private restoreSearchOrigin(origin) {
    this.loginService.lastSearchOrigin = null;
    this.fromd = origin.start;
    this.tod = origin.end;
    this.AWLlist = null;
    this.isAWL = false;
    switch (origin.kind) {
      case "reports":
        this.isReports = true;
        if (origin.criteria) this.searchHmoReport(origin.criteria, origin.failCase);
        break;
      case "legacyReport":
        this.isReports = true;
        this.examSearch(origin.reportName, origin.hmo);
        break;
      default:
        this.isReports = false;
        this.examVals = origin.exams;
        this.examMode = origin.mode;
        this.examSearch();
    }
  }

  searchClosed($event: any[]) {
    this.showExcel = true;
    if ($event && $event.length > 3) {
      this.fromd = $event[0];
      this.tod = $event[1];
      if (this.reportsNames.includes($event[3])) {
        this.examSearch($event[3], $event[4]);
      } else {
        this.examVals = $event[2];
        this.examMode = $event[3];
        this.examSearch();
      }
    }
    this.openEsearch = false;
  }

  // Criteria emitted by searchbox: the date range and a scope. 'AllReports' and
  // 'HMO' just list the period; 'StatusHMO' is the problem hunt, and only it
  // brings back the failure-case buckets so the radios above the results can
  // switch between the cases without searching again. `failCase` is only passed
  // when a search is being restored.
  searchHmoReport(criteria: ReportSearchCriteria, failCase?: ReportFailCase) {
    this.isAWL = false;
    this.AWLlist = null;
    this.examList = null;
    this.visitPat = null;
    this.patList = null;
    this.isReports = true;
    this.fromd = criteria.start;
    this.tod = criteria.end;
    this.openEsearch = false;
    this.reportSearchHmo = (criteria.hmo || "All") as any;
    this.reportStatusMode = criteria.mode === "StatusHMO";
    // Only a status search has cases to pick from, and a fresh one starts with
    // none picked - the counts say where the work is, the list waits.
    this.reportFailCase = this.reportStatusMode ? failCase || null : null;
    // Keep the criteria so re-opening the search panel starts from this search.
    this.loginService.lastReportSearch = criteria;
    this.exServ.searchReport = {
      start: this.fromd,
      end: this.tod,
      type: criteria.mode,
      hmo: this.reportSearchHmo,
    };
    this.examReportLoading = true;
    this.examReportResults = null;
    this.reportFailBuckets = null;
    this.reportFailCounts = null;

    const done = () => {
      this.examReportFading = true;
      setTimeout(() => {
        this.examReportLoading = false;
        this.examReportFading = false;
      }, SPINNER_FADEOUT_DURATION);
    };
    const failed = (error) => {
      console.error("searchHmoReport error", error);
      done();
    };

    // The private / IDF / unassigned group is not an HMO the API can filter on,
    // so it is fetched as every HMO and narrowed to those rows here. Both scope
    // selects offer it, so both paths below go through this.
    const others = this.reportSearchHmo === OTHER_HMOS_SCOPE;
    const queryHmo = others ? "All" : this.reportSearchHmo;
    const narrow = (rows: any[]) =>
      others ? (rows || []).filter((row) => !this.hasSending(row)) : rows || [];

    if (!this.reportStatusMode) {
      this.reportSearchNotSigned = false;
      this.exServ
        .getExamsReports(this.fromd, this.tod, "All", "all", queryHmo)
        .subscribe((data) => {
          this.examReportResults = narrow(data);
          done();
        }, failed);
      return;
    }

    this.exServ
      .getReportFailBuckets(this.fromd, this.tod, queryHmo)
      .subscribe((fetched) => {
        const buckets = {
          all: narrow(fetched.all),
          noPrn: narrow(fetched.noPrn),
          notSigned: narrow(fetched.notSigned),
        };
        const all = buckets.all;
        this.reportFailBuckets = {
          ...buckets,
          // Derived here rather than asked of the server: its sent/unsent
          // filter is only applied on the single-HMO branch, so status=unsent
          // with hmo=All comes back unfiltered. Same rule as the server's, and
          // as the per-row status text, applied per row to its own HMO so it
          // holds for one HMO and for all of them alike.
          notSent: all.filter(
            (row) => this.hasSending(row) && !this.everSent(row),
          ),
        };
        this.reportFailCounts = {
          // The whole scope, problems or not: neither the base query nor the
          // case queries filter by signature or PRN, so this is every gastro
          // exam of the period for the searched HMO(s).
          total: all.length,
          noPrn: (buckets.noPrn || []).length,
          notSigned: (buckets.notSigned || []).length,
          notSent: this.reportFailBuckets.notSent.length,
        };
        this.applyReportFailCase();
        done();
      }, failed);
  }

  // Lets the results screen switch HMO on its own, instead of sending the user
  // back through the Reports button to redo the whole search. Keeps the same
  // dates and mode (AllReports/HMO/StatusHMO) that produced the current list.
  changeReportHmo(newHmo: string) {
    if (!this.exServ.searchReport || newHmo === this.reportSearchHmo) return;
    const criteria: ReportSearchCriteria = {
      start: this.fromd,
      end: this.tod,
      mode: this.exServ.searchReport.type as ReportSearchMode,
      hmo: newHmo,
    };
    this.searchHmoReport(criteria);
  }

  // Nothing is ever sent for a private patient, the IDF or an exam with no HMO
  // on it, so those can never be "not sent" - they would otherwise fill the
  // list under the all-HMOs search with exams no secretary can act on. This is
  // the server's skipStatusFilter, per row rather than per search.
  private hasSending(exam: any): boolean {
    return !!exam.HMO && !NO_SEND_HMOS.includes(exam.HMO);
  }

  // Mirrors the server's everSent(): reportLog is the record of what actually
  // reached the HMO, with the marker columns as the fallback for exams sent
  // before reportLog existed. Macabi goes out over HTTP and older rows carry
  // only xmlDate.
  private everSent(exam: any): boolean {
    if (this.showReportLog && (exam.sendCount || 0) > 0) return true;
    return !!(exam.sftpSentDate || (exam.HMO === "Macabi" ? exam.xmlDate : null));
  }

  // Picking a failure case above the results. Exclusive, so the list is only
  // ever one case at a time.
  selectReportFail(failCase: ReportFailCase) {
    this.reportFailCase = failCase;
    this.applyReportFailCase();
  }

  // Each bucket already arrives ordered by the server (newest signature or
  // creation first), so listing a case is just handing its bucket over. No case
  // picked lists nothing: a status search is about the problems, and until one
  // is chosen the counts alone say where they are.
  private applyReportFailCase() {
    const buckets = this.reportFailBuckets;
    if (!buckets) return;
    // Nothing is generated or sent until an exam is signed, so a list of
    // unsigned exams has no send status to show for any of them.
    this.reportSearchNotSigned = this.reportFailCase === "notSigned";
    this.examReportResults = this.reportFailCase
      ? buckets[this.reportFailCase] || []
      : [];
  }

  setAWL(pat) {
    try {
      let edate = new Date(pat.ExamDate);
      this.awlTime = edate.getHours() + ":" + (edate.getMinutes() < 10 ? "0" : "") + edate.getMinutes();
    } catch {
      this.awlTime = null;
    }
    this.awlExamType = pat.ExamCode;

    this.awlLMP = pat.ExamLMP;
    this.awlComment = pat.Reason ? pat.Reason : null;

    this.chosenAWL = pat.AWLID;
  }
  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  saveComment(comment: string, AWLID: number) {
    this.patservice.saveAWLComment(comment, AWLID);
  }

  getcard() {
    this.card = "";
    setTimeout(() => {
      this.swipeField.nativeElement.focus();
    }, 100);
  }

  proccesscard(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;
    var card = this.card;
    if (this.card && this.card.length > 26 && this.card.includes("8=47"))
      //8=47 is the start of a macabi card
      card = this.card.substring(this.card.indexOf("8=47"));
    if (card && card.length > 26 && !this.cardtzsearch && !this.showpayment) {
      this.cardtzsearch = card.substring(7, 16);
      this.idcode = card.substring(6, 7);
      this.expcode = card.substring(16, 20);
      if (this.AWLStatus != "All") this.AWLStatus = "All";
      this.AWL(false);
    }
  }

  barscan(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;

    if (
      this.card.trim().length >= 12 &&
      (!this.last_search_time || Date.now() > this.last_search_time + 5000)
    ) {
      //belinson addmission code
      this.last_search_time = Date.now();
      this.patservice.findPatBelinson(this.card.trim()).subscribe(
        (patient: Patient) => {
          if (patient) {
            this.patList = [];
            this.isAWL = false;
            let pat = new Patient();
            pat.asignVals(patient);
            this.patList[0] = pat;
            this.setAWL(pat);
            this.selectedPatient = pat;
            this.swiping = false;
            this.card = "";
            this.awlTime = new Date().toTimeString().substring(0, 5);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  paymentNoCard() {
    this.showpayment = this.selectedPatient.ID;
    while (this.showpayment.length < 9) this.showpayment = "0" + this.showpayment.toString();
    this.idcode = "0";
    this.expcode = null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.patservice.closeWebSocket();
  }

  getStatus(status: string): string {
    //for cardio
    if (this.loginService.isCardio) {
      switch (status) {
        case "Completed":
          return "Performed";
        case "Waiting":
          return "Scheduled";
        case "Received":
          return "Waiting";
        default:
          return status;
      }
    } else return status;
  }

  setExamCode(pat) {
    var saveTitle = this.patservice.setExamCode(this.changedExamCode, pat.AWLID);
    saveTitle.subscribe((res) => {
      console.log(res);
      this.changedExamCode = null;
      this.AWL();
    });
  }

  setPatAwlid(pat) {
    this.gfs.paitentLoaded$.next(pat);
  }

  filterExams(exams, type, hmo = null) {
    if (!exams) return [];
    if (hmo) return exams.filter((i) => i.ExamType == type && i.HMO == hmo && i.PRN);
    return exams.filter((i) => i.ExamType == type);
  }

  export() {
    var table;
    var strTable;
    var items = ["CreationTime", "ID", "First", "Last", "HMO", "ExamType"];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    strTable = "<tr>";
    strTable +=
      "<td> חיפוש לפי</td><td>" +
      this.getType(this.exServ.searchReport.type) +
      "</td><td>" +
      this.getHMO(this.exServ.searchReport.hmo) +
      "</td>";
    strTable += "</tr><tr></tr>";
    strTable +=
      "<tr><td>תאריכים</td><td>" +
      this.getDate(this.exServ.searchReport.start) +
      "</td><td>" +
      this.getDate(this.exServ.searchReport.end) +
      "</td></tr>";

    if (this.examList.length > 0) {
      for (let name of this.examNames) {
        var examTable = "";
        examTable += "<tr>";
        table = document.createElement("table");
        examTable += `<td>${name}</td>`;
        examTable += "</tr>";
        examTable += "<tr>";
        for (let item of items) {
          examTable += `<td><strong>${item}</strong></td>`;
        }
        examTable += "</tr>";
        examTable += "<tr>";
        for (let exam of this.filterExams(this.examList, name)) {
          for (let item of items) {
            var date;
            if (item == "CreationTime") {
              date = exam[item].replace("T", " ").replace("Z", "");

              examTable += `<td>${date}</td>`;
            } else {
              examTable += `<td>${exam[item]}</td>`;
            }
          }
          examTable += "</tr>";
        }
        table.innerHTML = strTable + examTable;
        if (this.filterExams(this.examList, name).length > 0) {
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, name);
        }
      }
      XLSX.writeFile(wb, new Date().toISOString().split("T")[0] + ".xlsx");
      this.loginService.exportLoading = false;
      this.showLogin = false;
      this.sub.unsubscribe();
    }
  }

  sendMacabi() {
    this.patservice
      .sendMacabi(
        this.fromd["_i"].year +
          "-" +
          (this.fromd["_i"].month + 1 < 10 ? "0" : "") +
          (this.fromd["_i"].month + 1) +
          "-" +
          (this.fromd["_i"].date < 0 ? "0" : "") +
          this.fromd["_i"].date,
        this.tod["_i"].year +
          "-" +
          (this.tod["_i"].month + 1 < 10 ? "0" : "") +
          (this.tod["_i"].month + 1) +
          "-" +
          (this.tod["_i"].date < 0 ? "0" : "") +
          this.tod["_i"].date
      )
      .subscribe(
        (data) => {
          this.sentMacabi = true;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getHMO(hmo) {
    switch (hmo) {
      case "Macabi":
        return "מכבי";
      case "Leumit":
        return "לאומית";
      case "Meuhedet":
        return "מאוחדת";
      case "Clalit":
        return "כללית";
      case "Private":
        return "פרטי";
      case "IDF":
        return "צהל";
      case "null":
        return "לא שוייכו";
      default:
        return "הכל";
    }
  }
  getType(type) {
    switch (type) {
      case "Macabi":
        return "בדיקות שנשלחו למכבי";
      case "HMO":
        return "קופת חולים";
      case "Refferelnum":
        return "מס' הפניה חסר";
      default:
        return "הכל";
    }
  }
  getDate(date) {
    var temp = new Date(date);
    var str = temp.getDate() + "/" + (temp.getMonth() + 1) + "/" + temp.getFullYear();
    return str;
  }

  startForm(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    var res = this.exServ.getConcentForms(pat.PID);
    res.subscribe((data: any) => {
      console.log(data);
      if (!data.hasOwnProperty("empty")) {
        var temp = data.filter((i) => i.ExamType == pat.ExamCode && !i.ExamID);
        if (pat.ExamCode.split(" ")[1] == "Anatomy" || pat.ExamCode.split(" ")[1] == "Trimester")
          var temp = data.filter((i) => i.ExamType == pat.ExamCode.split(" ")[0] && !i.ExamID);
        if (temp.length > 0) {
          this.concentForm = temp[0];
        } else {
          this.exServ.concentForm = null;
          this.exServ.examID = null;
          this.exServ.pregId = null;
          this.exServ.pregnancies = null;
          this.concentForm = null;
        }
      } else {
        this.exServ.examID = null;
        this.exServ.pregId = null;
        this.exServ.pregnancies = null;
        this.exServ.concentForm = null;
        this.concentForm = null;
      }
      this.inform = true;
    });
  }
  getDoctors() {
    return this.loginService.clinicUsers;
  }

  /*reassign(){//move pat and todaylist to another doctor
    this.toreassign.UID = this.toreassign.nUID;
    this.toreassign.nUid = this.toreassign.UID;
    this.patservice.reassign(this.toreassign).subscribe((data)=>{
      this.toreassign = null;
      this.AWL();
    },(error)=>{
      this.toreassign = null;
      this.AWL();
      console.log(error)
    })
  } */ //geting rid of this

  closCalForm(event) {
    this.inform = false;
  }

  getDbName(i, str) {
    var t = i.replace("-", "").split(" ")[0];

    return str + t;
  }

  examTypeReportCount(examType: string): number {
    if (!this.examReportResults) return 0;
    return this.examReportResults.filter(e => e.ExamType === examType).length;
  }

  get pageTitle(): string {
    if (this.AWLlist) return "TodayList";
    if (this.examReportResults !== null) return "Reports";
    if (this.examList) return "Exams";
    return "Patients";
  }

  // The searched scope, spelled out - "Others" on its own says little.
  get reportSearchHmoLabel(): string {
    if (this.reportSearchHmo === OTHER_HMOS_SCOPE)
      return "Private / IDF / unassigned";
    if (this.reportSearchHmo === "null") return "Unassigned";
    if (this.reportSearchHmo === "All") return "All HMOs";
    return this.reportSearchHmo;
  }

  // Which failure case the listed rows were narrowed to.
  get reportSearchStatusLabel(): string {
    if (this.reportFailCase === "noPrn") return "No PRN";
    if (this.reportFailCase === "notSigned") return "Not Signed";
    if (this.reportFailCase === "notSent") return "Not Sent";
    return "All";
  }

  // Delivery history is only shown once reportLog has months of data behind
  // it; until then config.Env.showReportLog is false and the reports search
  // behaves exactly as it did before reportLog existed. The backend also skips
  // the query in that case, so sendCount arrives as 0 either way.
  get showReportLog(): boolean {
    return !!(this.gfs.env && this.gfs.env["showReportLog"]);
  }

  // Which HMO's rules a row is judged by. A search for one HMO judges every row
  // by it; the scopes that span HMOs ("All", and the private / IDF / unassigned
  // group) judge each row by its own.
  private rowHmo(exam: any): string {
    return ["All", OTHER_HMOS_SCOPE].includes(this.reportSearchHmo)
      ? exam.HMO
      : this.reportSearchHmo;
  }

  // sendCount comes from reportLog (append-only) and survives un-signing.
  // "resend" = an earlier version already reached the HMO and a corrected one
  // is due; without this it would look identical to "never sent", because
  // un-signing clears xmlDate / sftpSentDate / the staged columns.
  examReportsStatusLabel(
    exam: any,
  ): "sent" | "pending" | "resend" | "unsigned" | "unsent" {
    const hmo = this.rowHmo(exam);
    const everSent = this.showReportLog && (exam.sendCount || 0) > 0;
    // Nothing is generated or sent until an exam is signed, so an unsigned exam
    // is not "not sent" - it is not yet eligible to be sent at all. If it HAS
    // been sent before, the pending update still matters more than the bare
    // "unsigned", so keep showing it as a resend.
    if (!this.isSigned(exam)) return everSent ? "resend" : "unsigned";
    if (!hmo || NO_SEND_HMOS.includes(hmo)) return "unsent";
    // Macabi goes out over HTTP but now stamps sftpSentDate like the rest;
    // fall back to xmlDate for rows sent before that change.
    const currentMarker =
      exam.sftpSentDate || (hmo === "Macabi" ? exam.xmlDate : null);
    if (currentMarker) return "sent";
    const stagedDate =
      hmo === "Macabi"
        ? exam.xmlDate
        : hmo === "Leumit"
          ? exam.leumitPdfDate
          : hmo === "Meuhedet"
            ? exam.meuhedetPdfDate
            : exam.xmlDate;
    if (stagedDate) return "pending";
    // Nothing staged and no current marker: either awaiting a new version of
    // something already delivered, or never sent at all.
    return everSent ? "resend" : "unsent";
  }

  // Mirrors the server's signedSql(): signed means SignedDate and SignedBy are
  // both set and the exam is not a draft. Editing a signed exam drops the
  // signature, so Draft alone is enough to make it unsendable again.
  isSigned(exam: any): boolean {
    return !!(exam && exam.SignedDate && exam.SignedBy && !exam.Draft);
  }

  examReportsStatusText(exam: any): string {
    const hmo = this.rowHmo(exam);
    const stamp = (v: any) => {
      const d = new Date(v);
      return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
    };
    const sendCount = this.showReportLog ? exam.sendCount || 0 : 0;
    if (!this.isSigned(exam)) {
      if (sendCount > 0 && exam.lastSentDate)
        return `Sent ${stamp(exam.lastSentDate)} (v${sendCount}) - awaiting re-sign`;
      // SignedDate still set with Draft/SignedBy cleared means a doctor opened
      // it to edit; never signed at all means it has not reached them yet.
      return exam && exam.SignedDate
        ? "Signature dropped - awaiting re-sign"
        : "Not signed";
    }
    if (!hmo || NO_SEND_HMOS.includes(hmo))
      return "No sending configured";
    const currentMarker =
      exam.sftpSentDate || (hmo === "Macabi" ? exam.xmlDate : null);
    if (currentMarker) {
      const version = sendCount > 1 ? ` (v${sendCount})` : "";
      return `Sent ${stamp(currentMarker)}${version}`;
    }
    const stagedDate =
      hmo === "Macabi"
        ? exam.xmlDate
        : hmo === "Leumit"
          ? exam.leumitPdfDate
          : hmo === "Meuhedet"
            ? exam.meuhedetPdfDate
            : exam.xmlDate;
    if (stagedDate)
      return sendCount > 0
        ? `v${sendCount + 1} generated, awaiting send`
        : "Generated, awaiting send";
    if (sendCount > 0)
      return `Sent ${stamp(exam.lastSentDate)} (v${sendCount}) - update pending`;
    return "Not sent";
  }

  exporXmlList() {
    const hmo = this.reportSearchHmo;
    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);
    const datePipe = new DatePipe("en-US");
    const formatDate = (date: string) =>
      date ? datePipe.transform(date, "dd-MM-yyyy, HH:mm") : "";

    const filteredData = this.examReportResults.map((item) => {
      const generatedDate =
        hmo === "Leumit"
          ? item.leumitPdfDate || ""
          : hmo === "Meuhedet"
            ? item.meuhedetPdfDate || ""
            : item.xmlDate || "";
      const sentDate = ["Private", "IDF", "null"].includes(hmo)
        ? ""
        : item.sftpSentDate || (hmo === "Macabi" ? item.xmlDate || "" : "");
      const fileName =
        hmo === "Clalit"
          ? item.xmlName || ""
          : ["Leumit", "Meuhedet"].includes(hmo)
            ? item.pdfName || ""
            : "";
      // Fall back to reportLog when the current markers have been cleared by
      // an un-sign, so an exam awaiting version 2 does not export as blank.
      const everSentDate =
        sentDate || (this.showReportLog ? item.lastSentDate || "" : "");
      return {
        "Patient Name": `${item.First} ${item.Last}`,
        "Patient ID": item.PatientID,
        "Exam Date": formatDate(item.CreationTime),
        "Signed Date": formatDate(item.SignedDate),
        "Exam Type": item.ExamType,
        Generated: formatDate(generatedDate),
        [`Sent (${hmo})`]: formatDate(everSentDate),
        ...(this.showReportLog
          ? {
              "Times Sent": item.sendCount || 0,
              Status: this.examReportsStatusText(item),
            }
          : {}),
        "File Name": fileName,
      };
    });

    const sheetName = 'Report';
    const fileName = `${hmo} xml status from ${startDate} to ${endDate}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    worksheet["!cols"] = [
      { wch: 25 }, // Patient Name
      { wch: 12 }, // Patient ID
      { wch: 18 }, // Exam Date
      { wch: 18 }, // Signed Date
      { wch: 20 }, // Exam Type
      { wch: 18 }, // Generated
      { wch: 18 }, // Sent (hmo)
      ...(this.showReportLog
        ? [{ wch: 11 }, { wch: 34 }] // Times Sent, Status
        : []),
      { wch: 30 }, // File Name
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  generateXlExams(exams) {
    const datePipe = new DatePipe("en-US");
    let docName;
    if (!this.loginService.isAdmin) {
      docName = this.loginService.username;
    } else {
      docName = this.loginService.getDocByUID(this.loginService.doctor);
    }
    if (!docName) docName = "כולם";

    let clinicName = this.loginService.Clinic;
    if (clinicName === "Best Medical") {
      clinicName = "בסט מדיקל חדרה";
    } else if (clinicName === "Best Medical BY") {
      clinicName = "בסט מדיקל בת ים";
    }
    const filteredData = exams.map((item) => ({
      "תאריך קבלה": item.AdmissionFormTime ? datePipe.transform(item.AdmissionFormTime, "dd-MM-yyyy, HH:mm") : "",
      "תאריך הבדיקה": datePipe.transform(item.CreationTime, "dd-MM-yyyy, HH:mm") || "",
      "נחתם בתאריך": item.SignedDate ? datePipe.transform(item.SignedDate, "dd-MM-yyyy, HH:mm") : "",
      "נחתם על ידי": item.SignedBy || "",
      "תאריך שחרור": item.ReleaseFormTime ? datePipe.transform(item.ReleaseFormTime, "dd-MM-yyyy, HH:mm") : "",
      "ת.ז של הנבדק/ת": item.ID,
      "שם הנבדק/ת": `${item.First || ""} ${item.Last || ""}`,
      קופה: item.HMO || "",
      "סוג הבדיקה": item.ExamType,
      "שם רופא מבצע": item.OpenerName,
      "נחתם בעבר": (item.SignatureCount > 0 ? "כן" : "") || "",
    }));

    const totalExams = filteredData.length;
    const totalSignedExams = exams.filter((e) => e.SignatureCount > 0).length;
    const totalNotSignedExams = totalExams - totalSignedExams;

    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);

    const sheetName = "examsList";
    const fileName = `exams generated list from ${startDate} to ${endDate}.xlsx`;

    const worksheet = XLSX.utils.json_to_sheet([]);

    XLSX.utils.sheet_add_aoa(worksheet, [[clinicName]], { origin: "A1" });
    XLSX.utils.sheet_add_aoa(worksheet, [[`שם הרופא: ${docName}`]], { origin: "A2" });

    XLSX.utils.sheet_add_json(worksheet, filteredData, { origin: "A4" });

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          `סה"כ בדיקות: ${totalExams}`,
          `סה"כ בדיקות חתומות: ${totalSignedExams}`,
          `סה"כ בדיקות לא חתומות: ${totalNotSignedExams}`,
        ],
      ],
      { origin: "A3" }
    );

    worksheet["!cols"] = [{ wch: 30 }];
    const columnCount = Object.keys(filteredData[0] || {}).length;
    worksheet["!cols"] = Array(columnCount).fill({ wch: 30 });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  openHelp() {
    const rawPath = "/assets/pdf/gastro_guide.pdf";
    const encodedPath = encodeURI(rawPath);
    const fullUrl = window.location.origin + encodedPath;

    window.open(fullUrl, "_blank");
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: mark today-list patients whose questionnaire has been answered, for a
  // green check badge on the today-list questionnaire icon.
  private loadQuestionnaireStatuses(patients: any[]): void {
    if (!(this.loginService.premissions && this.loginService.premissions['Questionnaires'])) return;
    this.patQuestionnaireAnswered = {};
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      this.exServ.getPatientQuestionnaires(pat.PID).subscribe((data: any) => {
        const items = (data && data.items) || [];
        const answered = items.some((i: any) => i.answeredDate && (!pat.ExamCode || i.examCode === pat.ExamCode));
        if (answered) this.patQuestionnaireAnswered[pat.AWLID] = true;
      });
    }
  }

  printLabel(hmo:string,pid:number){
    this.patservice.printPatientLabel(hmo,pid).subscribe((data: any) => {}, error => {
      console.error('Error printing label:', error);
    });
  }
}
